export const GRAPHQL_API = '/graphql'
